import { DynamicTable } from '@/modules/dynamic_tables'
import { useVehicleColumnLabels } from '@/modules/vehicles/table-config'
import { Module } from '@/modules/companies/consts'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useMemo } from 'react'
import { OldSection, SectionHeader } from './common'
import { DynamicTableSettings } from './TableSettings'

/**
 * The columns of the three vehicle lists.
 *
 * Each list is rendered twice -- fleet-wide and on the vehicle's own "Utstyr
 * og materiell" tab -- and both read the same column rows, so what is set here
 * decides the order and the headers in both places at once.
 */
export const VehicleTableSettings: React.FC = () => {
  const translations = useTranslate({
    header: 'settings.vehicle-tables',
    info: 'settings.info.vehicle-tables',
    documents: 'vehicles.vehicle-documents',
    expirations: 'vehicles.expiration-dates',
    services: 'vehicles.vehicle-services',
  })

  const labels = useVehicleColumnLabels()

  const labelMaps = useMemo(
    () => ({
      [DynamicTable.VEHICLE_DOCUMENTS]: new Map(
        Object.entries(labels[DynamicTable.VEHICLE_DOCUMENTS])
      ),
      [DynamicTable.VEHICLE_EXPIRATIONS]: new Map(
        Object.entries(labels[DynamicTable.VEHICLE_EXPIRATIONS])
      ),
      [DynamicTable.VEHICLE_SERVICES]: new Map(
        Object.entries(labels[DynamicTable.VEHICLE_SERVICES])
      ),
    }),
    [labels]
  )

  return (
    <OldSection>
      <SectionHeader>{translations.header}</SectionHeader>
      <p className="mb-4 max-w-3xl text-sm text-stone-500">
        {translations.info}
      </p>

      <div className="flex flex-col gap-8">
        <DynamicTableSettings
          name={Module.VEHICLES}
          table={DynamicTable.VEHICLE_DOCUMENTS}
          title={translations.documents}
          labels={labelMaps[DynamicTable.VEHICLE_DOCUMENTS]}
          minEnabledColumns={1}
        />
        <DynamicTableSettings
          name={Module.VEHICLES}
          table={DynamicTable.VEHICLE_EXPIRATIONS}
          title={translations.expirations}
          labels={labelMaps[DynamicTable.VEHICLE_EXPIRATIONS]}
          minEnabledColumns={1}
        />
        <DynamicTableSettings
          name={Module.VEHICLES}
          table={DynamicTable.VEHICLE_SERVICES}
          title={translations.services}
          labels={labelMaps[DynamicTable.VEHICLE_SERVICES]}
          minEnabledColumns={1}
        />
      </div>
    </OldSection>
  )
}
